import { render, staticRenderFns } from "./highlightsApp.vue?vue&type=template&id=5d25ee46"
import script from "./highlightsApp.vue?vue&type=script&lang=js"
export * from "./highlightsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports